import { Box, useTheme } from "@mui/material";
import { darken } from "color2k";
import { useMediaQuery } from "../utilities/index.js";
import React from "react";
export const CardList = ({ backgroundColor = "#ffffff", children, containerStyles = {}, itemStyles = {}, listStyles = {}, }) => {
    const [itemWidth, setItemWidth] = React.useState(200);
    const theme = useTheme();
    const isAtLeastSm = useMediaQuery(theme.breakpoints.up("sm"));
    const borderColor = darken(backgroundColor, 0.1);
    React.useEffect(() => {
        if (typeof window === "undefined")
            return;
        const items = isAtLeastSm ? 3.35 : 2;
        const padding = items * 1.5 * 16;
        const itemWidth = (window.innerWidth - padding) / (items - 0.8);
        setItemWidth(itemWidth);
    }, [isAtLeastSm, setItemWidth]);
    return (React.createElement(Box, { component: "ul", sx: {
            backgroundColor,
            WebkitOverflowScrolling: "auto",
            "::-webkit-scrollbar": { width: "0px" },
            display: "flex",
            listStyleType: "none",
            my: -3,
            overflowX: { xs: "scroll", md: "visible" },
            overscrollBehaviorX: "none",
            px: 0,
            py: 3,
            scrollbarWidth: "none",
            width: "100%",
            "::after": {
                borderRightColor: "transparent",
                borderRightStyle: "solid",
                borderRightWidth: { xs: theme.spacing(3), sm: theme.spacing(4) },
                content: "''",
                display: { xs: "block", md: "none" },
            },
            "> li": {
                "&:first-of-type": { ml: { xs: 3, sm: 4, md: 0 } },
                "&:last-of-type": { mr: 0 },
                alignItems: "center",
                backgroundColor: "white",
                border: `1px solid ${borderColor}`,
                borderRadius: "16px",
                color: theme.palette.text.primary,
                display: "flex",
                flexDirection: "column",
                flexGrow: 0,
                flexShrink: 0,
                justifyContent: "flex-start",
                mx: { xs: 1.5 },
                overflow: "hidden",
                textAlign: "center",
                width: `${itemWidth}px`,
                ...itemStyles,
            },
            ".container": {
                pb: 6,
                pt: 7,
                px: 2,
                ...containerStyles,
            },
            ...listStyles,
        } }, children));
};
//# sourceMappingURL=card-list.js.map